module.exports = __webpack_public_path__ + "img/360.0d3da74b.svg";